export default __webpack_public_path__ + "static/winter23-3837755e4fc3cb43bb3af2aae2354de4.webp";